import React from 'react';

export default function HolidaySummaryCards({ summary, year }) {
  const cards = [
    {
      label: 'Total Holidays',
      value: String(summary?.total || 0),
      subtext: `Full Year ${year || '2026'}`,
      icon: 'calendar_month',
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Upcoming Holidays',
      value: String(summary?.upcoming || 0),
      subtext: 'Scheduled Ahead',
      icon: 'event_available',
      color: 'text-emerald-600',
      bg: 'bg-emerald-500/10',
    },
    {
      label: 'National & Gazetted',
      value: String(summary?.national || 0),
      subtext: 'Mandatory Company Closures',
      icon: 'flag',
      color: 'text-indigo-600',
      bg: 'bg-indigo-500/10',
    },
    {
      label: 'Restricted / Optional',
      value: String(summary?.restricted || 0),
      subtext: 'Optional Religious/Regional',
      icon: 'beach_access',
      color: 'text-amber-600',
      bg: 'bg-amber-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-5 shadow-xs transition-all hover:shadow-sm"
        >
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">
              {card.label}
            </span>
            <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${card.bg} ${card.color}`}>
              <span className="material-symbols-outlined text-lg">{card.icon}</span>
            </div>
          </div>
          <div className="mt-3">
            <span className="font-sans text-2xl font-extrabold text-on-surface tabular-nums tracking-tight">
              {card.value}
            </span>
            <p className="text-[11px] font-semibold text-slate-500 mt-0.5">{card.subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
